import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import Flex from 'components/Flex';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import Button from 'components/Button';
import VisuallyHidden from 'components/VisuallyHidden';
import RadioButtonOption from 'components/RadioButtonOption';
import InlineList from 'components/InlineList';
import { linkMyCalendar } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CalendarDisconnectedContent(_ref) {
  var defaultProvider = _ref.defaultProvider;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(defaultProvider),
    _useState2 = _slicedToArray(_useState, 2),
    provider = _useState2[0],
    setProvider = _useState2[1];
  var hintId = useUniqueId();
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "m",
    align: "center",
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(Text, {
      align: "left",
      children: t('auto_join_settings_not_connected_text')
    }), /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsxs(Trans, {
        t: t,
        i18nKey: "auto_join_settings_not_connected_privacy",
        children: ["We will only use your calendar data to determine which meetings to auto-join based on the rules you set as per our", /*#__PURE__*/_jsx(TextLink, {
          href: "https://trust-center.5app.com/guides/5app-platform-privacy-policy",
          target: "_blank",
          rel: "noopener noreferrer",
          children: "privacy policy"
        }), "."]
      })
    }), /*#__PURE__*/_jsx(VisuallyHidden, {
      id: hintId,
      children: t('actions_select_calendar_provider')
    }), /*#__PURE__*/_jsxs(InlineList, {
      spacing: "m",
      "aria-labelledby": hintId,
      children: [/*#__PURE__*/_jsx(RadioButtonOption, {
        bold: true,
        name: "calendar_provider",
        value: "google",
        label: t('property_google_calendar'),
        checked: provider === 'google',
        onChange: function onChange() {
          return setProvider('google');
        }
      }, "google"), /*#__PURE__*/_jsx(RadioButtonOption, {
        bold: true,
        name: "calendar_provider",
        value: "microsoft",
        label: t('property_microsoft_calendar'),
        checked: provider === 'microsoft',
        onChange: function onChange() {
          return setProvider('microsoft');
        }
      }, "microsoft")]
    }), /*#__PURE__*/_jsx(Button, {
      icon: "calendar",
      variant: "primary",
      isDisabled: !provider,
      onClick: function onClick() {
        if (!provider) return;
        linkMyCalendar(provider, 'authorise');
      },
      children: t('actions_connect_calendar')
    })]
  });
}
export default CalendarDisconnectedContent;